import apiClient from './client'

export interface Command {
  id: string
  machine_id: string
  command_type: string
  status: 'pending' | 'sent' | 'completed' | 'failed'
  result: Record<string, unknown> | null
  error: string | null
  created_at: string
  completed_at: string | null
  parameters: Record<string, unknown> | null
}

export interface CommandsResponse {
  commands: Command[]
  total: number
}

export type CommandType =
  | 'speedtest'
  | 'restart_network'
  | 'get_logs'
  | 'update_agent'
  | 'clean_linphone'
  | 'install_linphone'
  | 'fix_audio_config'
  | 'install_tailscale'
  | 'uninstall_tailscale'
  | 'install_activitywatch'
  | 'uninstall_activitywatch'
  | 'setup_echo_cancel'
  | 'deep_audio_diagnostic'
  | 'install_wifi_indicator'
  | 'uninstall_wifi_indicator'
  | 'disable_wifi_powersave'
  | 'set_audio_codec'
  | 'notify_operator'
  | 'force_emcall'
  | 'wifi_report'

export async function executeCommand(
  machineId: string,
  commandType: CommandType,
  payload?: Record<string, unknown>,
  queueIfOffline = false
): Promise<{ message: string; command_id: string; status?: string }> {
  const response = await apiClient.post(
    `/commands/${machineId}/execute`,
    payload,
    { params: { command_type: commandType, ...(queueIfOffline ? { queue_if_offline: true } : {}) } }
  )
  return response.data
}

export async function getCommandHistory(
  machineId: string,
  limit: number = 10
): Promise<CommandsResponse> {
  const response = await apiClient.get<CommandsResponse>(
    `/commands/${machineId}/commands`,
    { params: { limit } }
  )
  return response.data
}

export interface InstallTailscaleResponse {
  command_id: string
  machine_id: string
  command_type: 'install_tailscale'
  status: string
  hostname: string
}

export async function installTailscale(
  machineId: string,
  authkey: string,
  hostname: string
): Promise<InstallTailscaleResponse> {
  const response = await apiClient.post<InstallTailscaleResponse>(
    `/commands/${machineId}/install-tailscale`,
    { authkey, hostname }
  )
  return response.data
}

export async function uninstallTailscale(
  machineId: string,
  removePackage: boolean = false
): Promise<{ command_id: string; status: string }> {
  const response = await apiClient.post(
    `/commands/${machineId}/uninstall-tailscale`,
    { remove_package: removePackage }
  )
  return response.data
}
